class UserDataService {
  constructor(StorageService, JPMCService) {
    // Dependencies
    this.StorageService = StorageService;

    // Service Variables
    this.interests = this.StorageService.getItem('interests') || JPMCService.getConfig().interests;
    this.skills = this.StorageService.getItem('skills') || JPMCService.getConfig().skills;
    this.education = this.StorageService.getItem('education') || { 'id': '' };
    this.search = this.StorageService.getItem('search') || "";
    this.freshData = this.StorageService.getItem('freshData') !== null ? this.StorageService.getItem('freshData') : true;
    this.saveUserData('interests');
    this.saveUserData('skills');
    this.saveUserData('education');
    this.saveUserData('search');
    this.saveUserData('freshData');
  }
  saveUserData(key) {
    this.StorageService.setItem(key, this[key]);
    //console.log(key + ", " + this[key]);
  }
  saveString(key,val) {
    this.StorageService.setItem(key,val);
  }
  getAddress() {
    return this.StorageService.getItem('search');
  }
  getInterestById(id) {
    return this.interests.find((interest) => {
      return interest.id === id;
    });
  }
  getSkillById(id) {
    return this.skills.find((skill) => {
      return skill.id === id;
    });
  }
}

UserDataService.$inject = ['StorageService', 'JPMCService'];

export default UserDataService;



// WEBPACK FOOTER //
// ./src/services/userData.service.js